import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import am from './locales/am.json';
import or from './locales/or.json'; 
import had from './locales/had.json'; 
import tig from './locales/tig.json'; 
import so from './locales/so.json';
import { translate } from 'ol/transform';

  // 👈 Added Oromo


i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      am: { translation: am },
      or: { translation: or }, 
      had: { translation: had },   
      tig: { translation: tig }, 
      so:  { translation:   so},
    },

    lng: localStorage.getItem('lang') || 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
